import { DispatcherQuery } from 'dashboard-services/api/dispatcher';

import { useMutation, useQuery } from '@tanstack/react-query';

export default (() => {

  const useGetQueue = ({ getQueryBuilder, queueName, orderBy, shouldRefetch = true, shouldBeLimited, ...rest }) => 
    useQuery({
      ...DispatcherQuery.QUERIES.getQueue(getQueryBuilder, {
        type: queueName,
        orderBy
      }),
      refetchInterval: () => !shouldRefetch || shouldBeLimited() ? undefined : 5000,
      ...rest,
    })

  const useGroupPurge = ({ getQueryBuilder, type, groupName, onSuccess, queryClient, ...rest }) =>
    useMutation({
      ...DispatcherQuery.QUERIES.purgeGroup(
        getQueryBuilder,
        {
          type,
          groupName
        }
      ),
      onSuccess: () => {
        onSuccess?.()
        queryClient.invalidateQueries({ queryKey: DispatcherQuery.KEYS.GET_QUEUE() })
      },
      ...rest
    })
  
  const usePauseGroupQueue = ({ getQueryBuilder, type, groupName, onSuccess, queryClient, ...rest }) =>
    useMutation({
      ...DispatcherQuery.QUERIES.pauseGroup(
        getQueryBuilder,
        {
          type,
          groupName
        }
      ),
      onSuccess: () => {
        onSuccess?.()
        queryClient.invalidateQueries({ queryKey: DispatcherQuery.KEYS.GET_QUEUE() })
        queryClient.invalidateQueries({ queryKey: DispatcherQuery.KEYS.GET_PAUSED_GROUPS() })
      },
      ...rest
    })
  
  const useResumeGroupQueue = ({ getQueryBuilder, type, groupName, onSuccess, queryClient, ...rest }) =>
    useMutation({
      ...DispatcherQuery.QUERIES.resumeGroup(
        getQueryBuilder,
        {
          groupName,
          type
        }
      ),
      onSuccess: () => {
        onSuccess?.()
        queryClient.invalidateQueries({ queryKey: DispatcherQuery.KEYS.GET_PAUSED_GROUPS() })
        queryClient.invalidateQueries({ queryKey: DispatcherQuery.KEYS.GET_QUEUE() })
      },
      ...rest
    })
  
  const useRefreshPriorityCacheCall = ({ getQueryBuilder, type, groupName, onSuccess, queryClient, ...rest }) =>
    useMutation({
      ...DispatcherQuery.QUERIES.refreshGroup(
        getQueryBuilder,
        {
          groupName,
          type
        }
      ),
      onSuccess: () => {
        onSuccess?.()
        queryClient.invalidateQueries({ queryKey: DispatcherQuery.KEYS.GET_QUEUE() })
      },
      ...rest
    })

const useDispatchFileMessage = ({
  getQueryBuilder,
  queueType,
  fileId,
  groupName,
  fileName,
  fileFields,
  arrivalTime
}) =>
  useMutation({
    ...DispatcherQuery.QUERIES.dispatchMessage(
      getQueryBuilder,
      {
        type: queueType,
        fileMessage: {
          fileId,
          groupName,
          fileName,
          fileFields,
          arrivalTime
        }
      }
    )
  })

  return {
    useGetQueue,
    useGroupPurge,
    usePauseGroupQueue,
    useResumeGroupQueue,
    useRefreshPriorityCacheCall,
    useDispatchFileMessage,
  }
})()